import React from "react";
import MaunentCrownLogoIcon from "icon/MaunentCrownLogoIcon";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;
const fontCss = config.css.fontThickness;

const HEIGHT_OF_HEADER_DESKTOP = desktopCss.headerBarHeightPX;
const HEIGHT_OF_HEADER_MOBILE = mobileCss.logoBarHeightPX;
const zIndexOfHeader = config.css.zIndex.header;

const TITLE_TXT_RATIO_OF_MOBILE = 0.23;
const TITLE_TXT_RATIO_OF_DESKTOP = 0.29;
const RATIO_OF_LOGO = 0.28;

CustomHeaderTitleView.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  brandLogo: PropTypes.bool,
  displayOnMobile: PropTypes.bool,
  displayOnDesktop: PropTypes.bool,
  onLogoClick: PropTypes.func
};

CustomHeaderTitleView.defaultProps = {
  title: null,
  brandLogo: false,
  displayOnMobile: false,
  displayOnDesktop: false,
  onLogoClick: () => {}
};

function CustomHeaderTitleView(props) {
  const { title, brandLogo, onLogoClick, displayOnMobile, displayOnDesktop } =
    props;

  const deviceType = getDeviceType();
  const heightOfHeader =
    deviceType === "mobile"
      ? HEIGHT_OF_HEADER_MOBILE
      : HEIGHT_OF_HEADER_DESKTOP;
  const headerTitleTxtRatio =
    deviceType === "mobile"
      ? TITLE_TXT_RATIO_OF_MOBILE
      : TITLE_TXT_RATIO_OF_DESKTOP;

  const cssXL = {
    root: {
      height: heightOfHeader,
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: colorCss.colorOfBackground,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: zIndexOfHeader.customHeaderForMobile
    },
    logo: { height: heightOfHeader * RATIO_OF_LOGO }
  };
  const cssXS = {
    root: {
      height: heightOfHeader,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: colorCss.colorOfBackground,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: zIndexOfHeader.customHeaderForMobile
    },
    logo: { height: heightOfHeader * RATIO_OF_LOGO }
  };

  const TitleTypo = withStyles({
    root: {
      fontSize: heightOfHeader * headerTitleTxtRatio,
      fontWeight: fontCss.bold
    }
  })(Typography);

  if (deviceType !== "mobile" && !displayOnDesktop) return null;
  if (deviceType === "mobile" && !displayOnMobile) return null;

  const css = deviceType === "mobile" ? cssXS : cssXL;

  return (
    <div style={css.root}>
      {title ? (
        <TitleTypo>{title}</TitleTypo>
      ) : brandLogo ? (
        <ButtonBase onClick={onLogoClick}>
          <MaunentCrownLogoIcon style={css.logo} />
        </ButtonBase>
      ) : null}
    </div>
  );
}

export default CustomHeaderTitleView;
